module.exports = __webpack_public_path__ + "static/img/index-3.9533426.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/happyBirthday/index-3.png
// module id = CsFf
// module chunks = 1